import React, { useState } from 'react';
import { Box, CssBaseline, useTheme, useMediaQuery } from '@mui/material';
import AlertSideBar from '../OneShell/AlertSideBar/AlertSideBar';
import UserSideBar from '../OneShell/UserSideBar/UserSideBar';
import ChatIA from '../OneShell/ChatIA/ChatIA';
import useChatIaDisponivel from '../OneShell/ChatIA/useChatIaDisponivelHook';
import './styles.scss';
import { useMenuSidebar } from '../../contexts/MenuSidebarContext';
import LoaderPrincipalMain from './LoaderPrincipalMain';
import HeaderSideBarOld from './HeaderSideBarOld';
import HeaderSideBar from './HeaderSideBar';

const Main = ({ className, children, escopoAcesso, setEscopoAcesso, ...props }) => {
  const { window } = props;
  const [alertSideBarOpen, setAlertSideBarOpen] = useState(false);
  const [userSideBarOpen, setUserSideBarOpen] = useState(false);
  const [chatIaOpen, setChatIaOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(70);
  const theme = useTheme();
  const onlySmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [qtdIconeNotificacao, setQtdIconeNotificacao] = useState(false);
  const {
    scrIframe,
    setScrIframe,
    departamentoSelecionado,
    setDepartamentoSelecionado,
    loaderGeralMain,
    handleDrawerToggle,
    menuOpen,
    setMenuOpen,
    verificaHeaderSidebarNovo
  } = useMenuSidebar();

  const headerSidebarNovo = verificaHeaderSidebarNovo();
  const chatIaDisponivel = useChatIaDisponivel(escopoAcesso);

  return (
    <Box className="font-family-ibm-plex flex-box">
      <CssBaseline />

      {!headerSidebarNovo && (
        <HeaderSideBarOld
          window={window}
          menuOpen={menuOpen}
          drawerWidth={drawerWidth}
          setMenuOpen={setMenuOpen}
          escopoAcesso={escopoAcesso}
          setDrawerWidth={setDrawerWidth}
          onlySmallScreen={onlySmallScreen}
        />
      )}

      {headerSidebarNovo && (
        <HeaderSideBar
          window={window}
          menuOpen={menuOpen}
          drawerWidth={drawerWidth}
          setMenuOpen={setMenuOpen}
          setScrIframe={setScrIframe}
          escopoAcesso={escopoAcesso}
          setDrawerWidth={setDrawerWidth}
          setEscopoAcesso={setEscopoAcesso}
          onlySmallScreen={onlySmallScreen}
          setUserSideBarOpen={setUserSideBarOpen}
          handleDrawerToggle={handleDrawerToggle}
          setAlertSideBarOpen={setAlertSideBarOpen}
          qtdIconeNotificacao={qtdIconeNotificacao}
          departamentoSelecionado={departamentoSelecionado}
          setDepartamentoSelecionado={setDepartamentoSelecionado}
        />
      )}

      <AlertSideBar
        alertSideBarOpen={alertSideBarOpen}
        setAlertSideBarOpen={setAlertSideBarOpen}
        setQtdIconeNotificacao={setQtdIconeNotificacao}
      />

      <UserSideBar
        userSideBarOpen={userSideBarOpen}
        setUserSideBarOpen={setUserSideBarOpen}
        escopoAcesso={escopoAcesso}
      />

      {/* Gate no componente inteiro, nao no Fab interno: useChatIAHook assina o
          canal privado do Reverb e useSugestoesHook chama /chat-ia/v1/sugestoes.
          Esconder so o botao deixaria um WebSocket autenticado e requests 403 em
          toda navegacao de quem nao tem acesso. */}
      {chatIaDisponivel && <ChatIA chatIaOpen={chatIaOpen} setChatIaOpen={setChatIaOpen} />}

      <Box
        className={`${headerSidebarNovo ? 'margin-top-73' : 'margin-top-50'} font-family-ibm-plex box-main-style ${scrIframe ? 'pad-0' : ''}`}
      >
        {loaderGeralMain && <LoaderPrincipalMain />}
        {!loaderGeralMain && <main className={className}>{children}</main>}
      </Box>
    </Box>
  );
};

export default Main;
